/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Failedtofetchpermission3Inputs */

const en_common_error_failedtofetchpermission3 = /** @type {(inputs: Common_Error_Failedtofetchpermission3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to fetch permissions`)
};

/**
* | output |
* | --- |
* | "Failed to fetch permissions" |
*
* @param {Common_Error_Failedtofetchpermission3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_error_failedtofetchpermission3 = /** @type {((inputs?: Common_Error_Failedtofetchpermission3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Failedtofetchpermission3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_error_failedtofetchpermission3(inputs)
});
export { common_error_failedtofetchpermission3 as "common_error_failedToFetchPermission" }